import React, { useEffect, useState } from "react";
import { fetchAPI } from "../helper/fetchAPI";
import * as constants from "../constants";
import PropertyCard from "./PropertyCard";
import NotFoundSec from "../sections/pageNotFound/NotFoundSec";
import { t } from "i18next";
import AOS from "aos"; // Import AOS library
import { useTranslation } from "react-i18next";
import CustomImageComponent from "./CustomImageComponent";
import { useCountryPrefix } from "../routes/useCountryPrefix";

const PropertyList = (props) => {

    let apiUrl = process.env.REACT_APP_API_URL;
    const { propertyTypeData, propertiesData, developerDetailData, contact, isViewMore, isFilter, cssClass, isUrlAppend, onLoadMore, loadingMore = false } = props;
    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();

    const [propertyType, setPropertyType] = useState([]);
    const [properties, setProperties] = useState([]);
    const [developerDetail, setDeveloperDetail] = useState();
    const [contactDetails, setContactDetails] = useState();
    const [categoryId, setCategoryId] = useState();

    useEffect(() => {
        if (propertiesData?.items?.length > 0) {
            setPropertyType(propertyTypeData);
            setProperties(propertiesData?.items);
            setContactDetails(contact)
            setDeveloperDetail(developerDetailData)
            setCategoryId(constants.defaultPropertyType[propertyTypeData[0]?.propertyTypeId]?.label)

        }
    }, [propertiesData]);

    const handleCatClick = async (categoryId) => {
        try {
            debugger
            setCategoryId(constants.defaultPropertyType[categoryId]?.label)
            apiUrl = process.env.REACT_APP_API_URL
            const isArabic = i18n.language === "ar";
            const language = isArabic ? "ar" : "en";
            apiUrl = `${apiUrl}${constants.homepageCat}?language=${language}&propertyType=${categoryId}&region_id=${countryPrefix}`;
            const res = await fetchAPI(apiUrl, "Get");
            if (res?.status === 200) {
                setProperties(res.data);
            } else {
                setProperties([]);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleViewMoreClick = async () => {

        let url = categoryId
        const isArabic = i18n.language === "ar";
        const language = isArabic ? "/ar" : "";
        let baseUrl = window.location.origin + "/" + countryPrefix + language + "/search"
        const finalUrl = url === "" ? baseUrl : `${baseUrl}?pt=${url}`;
        window.location.href = finalUrl
    }

    useEffect(() => {
        AOS.refresh();
    }, [properties]);


    return (
        <>
            {propertyType && (
                <section
                    className={`property-listing-section ${cssClass}`}
                    data-aos="fade-up"
                    data-aos-duration="1500"
                >
                    <div className="container">
                        {isFilter ?? (
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                {propertyType?.length > 0 &&
                                    propertyType.slice(0, 6).map((item, index) => (
                                        <li className="nav-item" role="presentation" key={index}>
                                            <button
                                                // className="nav-link "
                                                className={`nav-link ${index === 0 ? "active" : ""}`}
                                                id={`tab-${index}`}
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile-tab-pane"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile-tab-pane"
                                                aria-selected="true"
                                                onClick={() => handleCatClick(item.propertyTypeId)}
                                            >
                                                <CustomImageComponent
                                                    src={constants.defaultPropertyType[item.propertyTypeId]?.image}
                                                    alt={constants.defaultPropertyType[item.propertyTypeId]?.label}
                                                    className={"img-fluid"}
                                                />
                                                {t(constants.defaultPropertyType[item.propertyTypeId]?.label)}
                                            </button>
                                        </li>
                                    ))}
                            </ul>
                        )}
                        <div className="tab-content" id="myTabContent">
                            <div
                                className="tab-pane fade show active"
                                id="profile-tab-pane"
                                role="tabpanel"
                                aria-labelledby="profile-tab"
                                tabIndex="0"
                            >
                                <div className="row">
                                    {properties?.length ?
                                        (properties.map((item, index) => (
                                            <div className="col-md-6 col-lg-4" key={index}>
                                                <PropertyCard
                                                    key={index}
                                                    propertyImg={item.image}
                                                    propertyAlt={item.title}
                                                    tag={item.badge}
                                                    delivery={item.delivery}
                                                    propertyId={item.propertyId}
                                                    developerDetailData={developerDetail}
                                                    propertyName={item.title}
                                                    propertyLocation={item.location}
                                                    propertyPrice={item.price}
                                                    propertyBed={item.features.bedCount}
                                                    propertyBath={item.features.bathCount}
                                                    propertySqft={item.features.areaSqft}
                                                    contactDetails={contactDetails}
                                                    isUrlAppend={isUrlAppend}
                                                    projectName={item?.projectName}
                                                    developerName={item?.developerName}
                                                ></PropertyCard>
                                            </div>
                                        ))) : (
                                            // <div className="col-md-6 col-lg-4"><p>No Propety Avalible</p></div>
                                            <NotFoundSec title={t("opps")} desc={t("property_not_found")} img={"/assets/img/not-found.svg"} />
                                        )}
                                    {/* Load More Button */}
                                    {propertiesData?.pageIndex < propertiesData?.totalPages && (
                                        <div className="text-center mt-4 mb-4">
                                            <button className="theme-btn theme-btn-secondary" onClick={onLoadMore} disabled={loadingMore}>
                                                {loadingMore ? (<i className="fa fa-spinner fa-spin fa-2x ms-0"></i>) : (t("load_more"))}
                                            </button>
                                        </div>
                                    )}
                                    {isFilter ?? (
                                        <div className="text-center mt-4 mb-4">
                                            <button className="theme-btn theme-btn-secondary" onClick={handleViewMoreClick}>
                                                {loadingMore ? (<i className="fa fa-spinner fa-spin fa-2x ms-0"></i>) : (t("view_more"))}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            )
                //  : (
                // <section
                //     className={`property-listing-section ${cssClass}`}
                //     data-aos="fade-up"
                //     data-aos-duration="1500"
                // ><div>sdfsd</div></section>
                // )
            }
        </>
    );
};

export default PropertyList;
